import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CalculatorFormItem {
	data: any;
	page: string;
}

export interface CalculatorFormState {
	[key: string]: CalculatorFormItem;
}

const initialState: CalculatorFormState = {};

export const calculatorFormSlice = createSlice({
	name: 'CalculatorFormSlice',
	initialState,
	reducers: {
		addFormItem: (state, action: PayloadAction<{ key: string; item: CalculatorFormItem }>) => {
			const { key, item } = action.payload;
			return {
				...state,
				[key]: item,
			};
		},
		resetFormItem: (state, action: PayloadAction<{ key: string }>) => {
			const { key } = action.payload;
			return {
				...state,
				[key]: undefined,
			};
		},
		// Seeds metaArea.staticFields into the form slice verbatim, so any component or service
		// can read them via state.calculatorForm[uid]. Numeric consumers (calculate API,
		// validation) parse on read via `parseDanishAmount`; display consumers render as-is
		// or run the value through `formatValue` for canonical formatting.
		loadStaticFieldsToForm: (state, action: PayloadAction<MetaArea>) => {
			const staticFieldItems = action.payload?.items?.[0]?.content?.staticFields?.items;
			if (!staticFieldItems?.length) {
				return state;
			}

			const next: CalculatorFormState = { ...state };
			for (const item of staticFieldItems) {
				const content = item?.content;
				const key = content?.uniqueIdentifier?.uid;
				if (!key || next[key]?.data) continue;
				next[key] = {
					data: {
						id: key,
						value: content?.defaultValue,
						type: content?.contentType,
					},
					page: '0',
				};
			}
			return next;
		},
	},
});

export const { addFormItem, resetFormItem, loadStaticFieldsToForm } = calculatorFormSlice.actions;

export default calculatorFormSlice.reducer;
